import { render, staticRenderFns } from "./ItemOptions.vue?vue&type=template&id=5f8b3ce2&scoped=true&"
import script from "./ItemOptions.vue?vue&type=script&lang=js&"
export * from "./ItemOptions.vue?vue&type=script&lang=js&"
import style0 from "./ItemOptions.vue?vue&type=style&index=0&id=5f8b3ce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8b3ce2",
  null
  
)

export default component.exports